import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Check, Eye, Lightbulb } from "lucide-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { saveOrderData, getOrderData, type SelectedActivity } from "@/lib/storage";
import { supabase } from "@/integrations/supabase/client";
import type { User } from "@supabase/supabase-js";
interface Activity {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
  variants?: {
    id: string;
    label: string;
    value: string;
    image?: string;
  }[];
}
const activities: Activity[] = [{
  id: 1,
  name: "Puzzle personnalisé",
  description: "Choisissez votre photo et créez un puzzle 1000 pièces personnalisé !",
  image: "/lovable-uploads/ad7fac07-bb16-4ca9-98a9-704b804b2ab3.png",
  category: "Créatif"
}, {
  id: 2,
  name: "Kit pour faire pousser ses propres plantes",
  description: "Kit de jardinage complet : herbes aromatiques, cactus ou bonzaï à cultiver.",
  image: "/lovable-uploads/3684dd22-b0f2-43ff-8143-89f55281de80.png",
  category: "Activité manuelle",
  variants: [{
    id: "jardin-1",
    label: "Kit herbe aromatique",
    value: "kit herbe aromatique",
    image: "/lovable-uploads/3684dd22-b0f2-43ff-8143-89f55281de80.png"
  }, {
    id: "jardin-2",
    label: "Kit Cactus",
    value: "kit cactus",
    image: "/lovable-uploads/fc64caef-7b17-448c-9896-d4acf73d4d92.png"
  }, {
    id: "jardin-3",
    label: "Kit Bonzaï",
    value: "kit bonzaï",
    image: "/lovable-uploads/502470bc-6927-49dc-84bc-c6b30cb4f384.png"
  }]
}, {
  id: 5,
  name: "Kit peinture écologique et DIY",
  description: "Fabriquez votre propre peinture à partir de matériaux 100% écologiques.",
  image: "/lovable-uploads/3847ac7e-ced9-4f12-bfeb-5d9586ab6c8a.png",
  category: "Activité manuelle"
}, {
  id: 7,
  name: "Kit de broderie pour débutant",
  description: "Kit débutant avec 4 motifs floraux, instructions et vidéos incluses.",
  image: "/lovable-uploads/3be6d83f-b896-41ca-a229-f5b81666ea30.png",
  category: "Activité manuelle"
}, {
  id: 6,
  name: "Livre Raconte ton histoire",
  description: "Journal unique avec 175 questions pour transmettre souvenirs et sagesse.",
  image: "/lovable-uploads/b2d82e88-70f2-4852-90e9-87f999a09e85.png",
  category: "Mémoriel",
  variants: [{
    id: "livre-1",
    label: "Pour Papi",
    value: "livre raconte ton histoire pour papi"
  }, {
    id: "livre-2",
    label: "Pour Mamie",
    value: "livre raconte ton histoire pour mamie"
  }]
}, {
  id: 8,
  name: "Écouter des souvenirs musicaux",
  description: "Playlist personnalisée des plus belles chansons du passé sur CD, vinyle ou USB.",
  image: "/lovable-uploads/7e9193e9-432c-48b1-a389-22ba17be6e02.png",
  category: "Loisir",
  variants: [{
    id: "musique-1",
    label: "CD",
    value: "cd",
    image: "/lovable-uploads/7e9193e9-432c-48b1-a389-22ba17be6e02.png"
  }, {
    id: "musique-2",
    label: "Vinyle",
    value: "vinyle",
    image: "/lovable-uploads/7e9193e9-432c-48b1-a389-22ba17be6e02.png"
  }, {
    id: "musique-3",
    label: "Clé USB",
    value: "usb",
    image: "/lovable-uploads/7e9193e9-432c-48b1-a389-22ba17be6e02.png"
  }]
}, {
  id: 9,
  name: "Apprendre à dessiner",
  description: "Kit complet avec livre tutoriel pour s'initier au dessin pas à pas.",
  image: "/lovable-uploads/646bff39-4a82-468a-8d15-739dba499ff1.png",
  category: "Créatif"
}, {
  id: 10,
  name: "Kit d'argile créative",
  description: "1,5kg d'argile, peinture, vernis et vidéos tutoriels pour créer des objets décoratifs.",
  image: "/lovable-uploads/631ee35a-8387-4169-8964-8e631ce80717.png",
  category: "Activité manuelle"
}, {
  id: 11,
  name: "Soirée casino",
  description: "Coffret casino complet avec mélangeur, cartes et jetons pour jouer à domicile.",
  image: "/lovable-uploads/52d07fe8-ed5e-4a92-931f-587e434109a4.png",
  category: "Loisir"
}, {
  id: 16,
  name: "Initiation au crochet",
  description: "Kit complet pour apprendre le crochet et confectionner une adorable peluche.",
  image: "/lovable-uploads/1d7e235f-db21-4097-b873-ad6036fae15e.png",
  category: "Créatif",
  variants: [{
    id: "crochet-1",
    label: "Koala",
    value: "koala"
  }, {
    id: "crochet-2",
    label: "Teckel",
    value: "teckel"
  }, {
    id: "crochet-3",
    label: "Lion",
    value: "lion"
  }, {
    id: "crochet-4",
    label: "Lapin",
    value: "lapin"
  }, {
    id: "crochet-5",
    label: "Renard",
    value: "renard"
  }, {
    id: "crochet-6",
    label: "Castor",
    value: "castor"
  }, {
    id: "crochet-7",
    label: "Phoque",
    value: "phoque"
  }, {
    id: "crochet-8",
    label: "Chat",
    value: "chat"
  }]
}, {
  id: 17,
  name: "Initiation au sport doux",
  description: "Coffret sportif avec poids, élastique et vidéos pour garder la forme en douceur.",
  image: "/lovable-uploads/91f9d140-80bf-45df-b8c6-dbae6cac3142.png",
  category: "Bien-être",
  variants: [{
    id: "sport-1",
    label: "Haltères 0.5kg",
    value: "halteres-0.5kg"
  }, {
    id: "sport-2",
    label: "Haltères 1kg",
    value: "halteres-1kg"
  }]
}, {
  id: 18,
  name: "Kit de tricot",
  description: "Kit de tricot avec guide complet pour fabriquer un vêtement unique.",
  image: "/lovable-uploads/b391ae0b-4d79-4223-99f0-bcea421a8fb3.png",
  category: "Créativité",
  variants: [{
    id: "tricot-1",
    label: "Bleu foncé & turquoise",
    value: "bleu-turquoise"
  }, {
    id: "tricot-2",
    label: "Pastel",
    value: "pastel"
  }, {
    id: "tricot-3",
    label: "Marron & blanc",
    value: "marron-blanc"
  }, {
    id: "tricot-4",
    label: "Multicolor",
    value: "multicolor"
  }]
}, {
  id: 19,
  name: "Moment de bien-être",
  description: "Kit bien-être complet : masques, gommage, vernis, chaussettes et tisanes relaxantes.",
  image: "/lovable-uploads/9a2e9595-b7f6-40ad-84df-d94ad6b4516d.png",
  category: "Bien-être"
}, {
  id: 20,
  name: "Kit initiation aux origami",
  description: "Initiation complète avec plus de 50 modèles d'origami expliqués pas à pas.",
  image: "/lovable-uploads/842b3f37-e438-4ee2-b9c7-4fdf1f85b833.png",
  category: "Créatif"
}, {
  id: 21,
  name: "Créer son carnet de recettes familiales",
  description: "Carnet structuré pour créer un livre de cuisine personnalisé et familial.",
  image: "/lovable-uploads/e4f2cfc0-6bbf-494c-bdeb-c68f654dbda1.png",
  category: "Mémoriel"
}];
const Activities = () => {
  const navigate = useNavigate();
  const [selectedActivities, setSelectedActivities] = useState<number[]>([]);
  const [activityVariants, setActivityVariants] = useState<Record<number, string>>({});
  const [user, setUser] = useState<User | null>(null);
  const [customPhotoUrls, setCustomPhotoUrls] = useState<Record<number, string>>({});
  useEffect(() => {
    // Charger les données sauvegardées au démarrage
    const orderData = getOrderData();
    if (orderData && orderData.orderType === 'custom') {
      setSelectedActivities(orderData.selectedActivities.map(a => a.id));
      if (orderData.activityVariants) {
        setActivityVariants(orderData.activityVariants);
      }
      // Charger les URLs des photos personnalisées
      const photoUrls: Record<number, string> = {};
      orderData.selectedActivities.forEach(activity => {
        if (activity.customPhotoUrl) {
          photoUrls[activity.id] = activity.customPhotoUrl;
        }
      });
      setCustomPhotoUrls(photoUrls);
    }

    // Vérifier l'état de connexion de l'utilisateur
    const checkUser = async () => {
      const {
        data: {
          session
        }
      } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
    };
    checkUser();
    const {
      data: {
        subscription
      }
    } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);
  const toggleActivity = (activityId: number) => {
    const activity = activities.find(a => a.id === activityId);
    if (activity?.variants) {
      // Pour les activités avec variants, ne pas ajouter directement
      // Vérifier si une variante est sélectionnée
      const selectedVariant = activityVariants[activityId];
      if (!selectedVariant) return; // Ne pas ajouter sans variant sélectionné
    }
    
    // Pour le puzzle personnalisé, vérifier qu'une photo est uploadée
    if (activityId === 1 && !customPhotoUrls[1]) {
      return; // Ne pas permettre l'ajout sans photo
    }
    const newSelected = selectedActivities.includes(activityId) ? selectedActivities.filter(id => id !== activityId) : [...selectedActivities, activityId];
    setSelectedActivities(newSelected);

    // Sauvegarder les activités sélectionnées
    const selectedActivityData: SelectedActivity[] = newSelected.map(id => {
      const activity = activities.find(a => a.id === id);
      if (!activity) return null;
      let activityName = activity.name;
      let selectedVariant = undefined;
      if (activity.variants && activityVariants[id]) {
        const variant = activity.variants.find(v => v.value === activityVariants[id]);
        activityName = `${activity.name} - ${variant?.label || activityVariants[id]}`;
        selectedVariant = activityVariants[id];
      }
      return {
        id: activity.id,
        name: activityName,
        description: activity.description,
        image: activity.image,
        category: activity.category,
        variant: selectedVariant,
        customPhotoUrl: customPhotoUrls[activity.id]
      };
    }).filter(Boolean) as SelectedActivity[];
    saveOrderData({
      orderType: 'custom',
      selectedActivities: selectedActivityData,
      activityVariants: activityVariants,
      frequency: 3
    });
  };
  const getCategoryColor = (category: string) => {
    switch (category) {
      case "Créatif":
        return "bg-primary text-primary-foreground";
      case "Mémoriel":
        return "bg-warm-brown text-white";
      case "Loisir":
        return "bg-primary-light text-white";
      case "Bien-être":
        return "bg-accent-foreground text-white";
      case "Activité manuelle":
        return "bg-secondary text-secondary-foreground";
      default:
        return "bg-muted text-muted-foreground";
    }
  };
  return <section id="activites" className="py-16 bg-background">
      <div className="container mx-auto px-4">
        {/* Panier d'activités sélectionnées */}
        {selectedActivities.length > 0 && <Card className="p-6 mb-8 bg-primary/5 border-primary/20 text-center">
            <h3 className="text-2xl font-semibold mb-4 text-primary">
              Activités sélectionnées ({selectedActivities.length})
            </h3>
            <div className="flex flex-wrap gap-2 justify-center">
              {selectedActivities.map(id => {
            const activity = activities.find(a => a.id === id);
            return activity ? <Badge key={id} variant="secondary" className="text-sm bg-white">
                    {activity.name}
                  </Badge> : null;
          })}
            </div>
            <a href={user ? "/commande" : "/connexion?redirect=/commande"}>
              <Button className="mt-4 bg-primary hover:bg-primary/90" size="lg">
                Voir votre panier
              </Button>
            </a>
          </Card>}

        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-4">Composez vous-même les box de votre grand-parent</h2>
        </div>

        {/* Encadré astuce */}
        <div className="bg-background border-l-4 border-primary p-6 mb-8 rounded-lg shadow-sm border border-primary/30">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <Lightbulb className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-primary mb-2">Astuce</h3>
              <p className="text-foreground leading-relaxed">Vous pouvez choisir autant d'activités que vous le désirez. Une activité sera envoyée par mois. Nous vous préviendrons un mois avant la dernière activité pour que vous puissiez en choisir de nouvelles. Si vous oubliez de choisir de nouvelles activités, pas de panique ! On s'en chargera pour vous.</p>
            </div>
          </div>
        </div>


        {/* Grille d'activités */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {activities.map(activity => {
          const isSelected = selectedActivities.includes(activity.id);
          const selectedVariant = activityVariants[activity.id];
          const currentImage = activity.variants && selectedVariant ? activity.variants.find(v => v.value === selectedVariant)?.image || activity.image : activity.image;
          const hasCustomPhoto = customPhotoUrls[activity.id];
          const isPuzzleActivity = activity.id === 1;
          
          // Vérifier si l'activité peut être sélectionnée
          const canSelect = !activity.variants || selectedVariant;
          const canSelectPuzzle = !isPuzzleActivity || hasCustomPhoto;
          return <Card 
            key={activity.id} 
            className={`overflow-hidden shadow-soft hover:shadow-warm transition-all duration-300 cursor-pointer border-2 ${isSelected ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/30'}`} 
            onClick={() => toggleActivity(activity.id)}
            onDoubleClick={(e) => {
              e.stopPropagation();
              navigate(`/activite/${activity.id}`);
              window.scrollTo(0, 0);
            }}
          >
                <div className="aspect-video bg-muted relative">
                  <img src={currentImage} alt={activity.name} className="w-full h-full object-cover transition-all duration-300" />
                  <Badge className={`absolute top-3 left-3 ${getCategoryColor(activity.category)}`}>
                    {activity.category}
                  </Badge>
                  {isSelected && <div className="absolute top-3 right-3 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                      <Check className="w-5 h-5 text-primary-foreground" />
                    </div>}
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold mb-2 text-foreground">
                    {activity.name}
                  </h3>
                   <div className="mb-4">
                     <p className="text-muted-foreground text-sm leading-relaxed">
                       {activity.description}
                     </p>
                   </div>
                   
                   {/* Choix des options en menu déroulant */}
                   {activity.variants && <div className="mb-4">
                       <Select value={activityVariants[activity.id] || ""} onValueChange={value => {
                  setActivityVariants(prev => ({
                    ...prev,
                    [activity.id]: value
                  }));
                }}>
                         <SelectTrigger className="w-full">
                           <SelectValue placeholder="Choisir une option" />
                         </SelectTrigger>
                         <SelectContent className="bg-background border shadow-lg z-50">
                           {activity.variants.map(variant => <SelectItem key={variant.id} value={variant.value}>
                               {variant.label}
                             </SelectItem>)}
                         </SelectContent>
                       </Select>
                     </div>}
                     
                      <div className="space-y-2">
                        <Button 
                          variant={isSelected ? "default" : (!canSelect || !canSelectPuzzle) ? "secondary" : "outline"} 
                          size="sm" 
                          className={`w-full transition-all ${
                            isSelected 
                              ? 'bg-primary hover:bg-primary/90' 
                              : (!canSelect || !canSelectPuzzle) 
                                ? 'bg-muted text-muted-foreground cursor-not-allowed' 
                                : 'border-primary text-primary hover:bg-primary hover:text-primary-foreground'
                          }`} 
                          disabled={!canSelect || !canSelectPuzzle}
                        >
                          {isSelected ? (
                            <>
                              <Check className="w-4 h-4 mr-2" />
                              Sélectionnée
                            </>
                          ) : isPuzzleActivity && !hasCustomPhoto ? (
                            "Vous devez upload une photo pour sélectionner cette activité"
                          ) : activity.variants && !selectedVariant ? (
                            "Choisir une option avant de sélectionner l'activité"
                          ) : (
                            <>
                              <Plus className="w-4 h-4 mr-2" />
                              Ajouter à ma liste
                            </>
                          )}
                        </Button>
                       <Button variant="ghost" size="sm" className="w-full bg-green-800 hover:bg-green-900 text-white hover:text-white" onClick={e => {
                  e.stopPropagation();
                  navigate(`/activite/${activity.id}`);
                  window.scrollTo(0, 0);
                }}>
                         Plus de détails
                       </Button>
                    </div>
                </div>
              </Card>;
        })}
        </div>

        <div className="bg-primary-light/20 border border-primary-light/30 rounded-lg p-6 mb-8 text-center">
          <h2 className="text-xl font-semibold mb-4 text-primary">
            Vous préférez nous laisser choisir ?
          </h2>
          <p className="text-muted-foreground mb-4">
            Décrivez-nous votre grand-parent en quelques phrases et nous sélectionnerons les activités parfaites selon ses goûts, sa mobilité et ses passions.
          </p>
          <a href="/commande?mode=curated">
            <Button variant="outline" className="border-primary text-primary hover:bg-primary/10">
              Je préfère vous laisser choisir
            </Button>
          </a>
        </div>

      </div>
    </section>;
};
export default Activities;